import {
  Dashboard,
  UserInformations
} from "../pages";

export const pageNames = {
  home: `Home`,
  userInformations: `UserProfile`,
};

export const routePaths = {
  home: `/`,
  userInformations: `/:userId/`,
};

export const PAGE_ENUMS = {
  HOME: 1,
  USERINFORMATIONS: 2,
};

export const privateRoutes = {
  // [routePaths.home]: {
  //   name: pageNames.home,
  //   path: routePaths.home,
  //   component: Dashboard,
  //   selectedId: PAGE_ENUMS.HOME,
  // },
  // [routePaths.companySignup]: {
  //   name: pageNames.locations,
  //   path: routePaths.locations,
  //   component: Dashboard,
  //   selectedId: PAGE_ENUMS.LOCATIONS,
  // },
};

export const publicRoutes = {
  [routePaths.home]: {
    name: pageNames.home,
    path: routePaths.home,
    component: Dashboard,
  },
  [routePaths.userInformations]: {
    name: pageNames.userInformations,
    path: routePaths.userInformations,
    component: UserInformations,
  },
};
